// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","settings":"Egv1ph5WZfCSdeIm","title":"uaxoHylc44dyL6lp","subtitle":"fR_TH_MGrlCjYSDP","error":"dd1C41rshPYOLaua"};